"use strict";
exports.__esModule = true;
exports.GetAccountCategoryType = exports.AccountTagName = exports.AccountEnterOnboardingCategory = exports.ProductConnectionCategoryType = exports.ProductConnectionProductType = exports.ProductConnectionOfferStateLegacy = exports.ProductConnectionOfferState = exports.ProductConnectionStatus = exports.CustomerCustomerType = exports.CustomerStatus = exports.EvaluationInstruction = exports.PortalCredentialUpdateErrorCode = exports.AccountErrorCode = exports.OfferStatus = exports.BillerConnectionStatus = exports.IdentityStatus = exports.ConnectionType = void 0;
var ConnectionType;
(function (ConnectionType) {
    ConnectionType["FLEX"] = "FLEX";
    ConnectionType["EMBED"] = "EMBED";
})(ConnectionType = exports.ConnectionType || (exports.ConnectionType = {}));
var IdentityStatus;
(function (IdentityStatus) {
    IdentityStatus["ACTIVE"] = "ACTIVE";
    IdentityStatus["CANCELED"] = "CANCELED";
    IdentityStatus["DELETED"] = "DELETED";
})(IdentityStatus = exports.IdentityStatus || (exports.IdentityStatus = {}));
var BillerConnectionStatus;
(function (BillerConnectionStatus) {
    BillerConnectionStatus["NEW"] = "NEW";
    BillerConnectionStatus["ACTIVE"] = "ACTIVE";
    BillerConnectionStatus["PAUSED"] = "PAUSED";
    BillerConnectionStatus["PENDING"] = "PENDING";
    BillerConnectionStatus["NO_MATCH"] = "NO_MATCH";
    BillerConnectionStatus["MATCHING"] = "MATCHING";
    BillerConnectionStatus["INACTIVE"] = "INACTIVE";
    BillerConnectionStatus["CLOSED"] = "CLOSED";
})(BillerConnectionStatus = exports.BillerConnectionStatus || (exports.BillerConnectionStatus = {}));
var OfferStatus;
(function (OfferStatus) {
    OfferStatus["UNKNOWN"] = "UNKNOWN";
    OfferStatus["ONBOARDING"] = "ONBOARDING";
    OfferStatus["ACCEPTED"] = "ACCEPTED";
})(OfferStatus = exports.OfferStatus || (exports.OfferStatus = {}));
var AccountErrorCode;
(function (AccountErrorCode) {
    AccountErrorCode["UnexpectedFailure"] = "A40000";
    AccountErrorCode["OfferAcceptenceTokenExpired"] = "A40001";
    AccountErrorCode["EmailAlreadyVerified"] = "A40002";
    AccountErrorCode["MagicLinkTokenInvalid"] = "A40003";
    AccountErrorCode["MagicLinkTokenExpired"] = "A40004";
    AccountErrorCode["EmailNotVerified"] = "A40005";
    AccountErrorCode["NotUpdateEligible"] = "A40006";
    AccountErrorCode["PhoneNumberInvalid"] = "A40007";
    AccountErrorCode["PhoneNumberVerificationCodeInvalid"] = "A40008";
    AccountErrorCode["NotDeleteEligbile"] = "A40009";
    AccountErrorCode["NotCancelAccountEligible"] = "A40010";
    AccountErrorCode["PhoneInUse"] = "A40011";
    AccountErrorCode["AccountNotFound"] = "A40012";
    AccountErrorCode["EmailAlreadyInUse"] = "A40017";
    AccountErrorCode["EmailInvalid"] = "A40021";
})(AccountErrorCode = exports.AccountErrorCode || (exports.AccountErrorCode = {}));
var PortalCredentialUpdateErrorCode;
(function (PortalCredentialUpdateErrorCode) {
    PortalCredentialUpdateErrorCode["UnexpectedFailure"] = "A40000";
    PortalCredentialUpdateErrorCode["IncorrectCredentials"] = "A41001";
    PortalCredentialUpdateErrorCode["ResetNeeded"] = "A41002";
    PortalCredentialUpdateErrorCode["MissingLease"] = "A41003";
    PortalCredentialUpdateErrorCode["MoreThanOneLease"] = "A41004";
    PortalCredentialUpdateErrorCode["IncorrectPortal"] = "A41005";
    PortalCredentialUpdateErrorCode["TwoFactor"] = "A41006";
    PortalCredentialUpdateErrorCode["ConnectionFailure"] = "A41007";
})(PortalCredentialUpdateErrorCode = exports.PortalCredentialUpdateErrorCode || (exports.PortalCredentialUpdateErrorCode = {}));
var EvaluationInstruction;
(function (EvaluationInstruction) {
    EvaluationInstruction["EvaluationCompleted"] = "EvaluationCompleted";
    EvaluationInstruction["InProgress"] = "InProgress";
    EvaluationInstruction["SystemOutageRetryLater"] = "SystemOutageRetryLater";
    EvaluationInstruction["ManualReview"] = "ManualReview";
    EvaluationInstruction["NeedsFurtherVerification"] = "NeedsFurtherVerification";
    EvaluationInstruction["Resubmit"] = "Resubmit";
    EvaluationInstruction["ErrorState"] = "ErrorState";
})(EvaluationInstruction = exports.EvaluationInstruction || (exports.EvaluationInstruction = {}));
exports.CustomerStatus = {
    ACTIVE: 'ACTIVE',
    DELETED: 'DELETED',
    BLOCKED: 'BLOCKED'
};
exports.CustomerCustomerType = {
    NORMAL: 'NORMAL',
    VETERAN: 'VETERAN',
    PMC_EMPLOYEE: 'PMC_EMPLOYEE',
    FLEX_EMPLOYEE: 'FLEX_EMPLOYEE',
    ACTIVE_DUTY_MILITARY: 'ACTIVE_DUTY_MILITARY'
};
exports.ProductConnectionStatus = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    ROLLOVER: 'ROLLOVER',
    DELINQUENT: 'DELINQUENT',
    CANCELED: 'CANCELED',
    SUSPENDED: 'SUSPENDED',
    INACTIVE: 'INACTIVE'
};
exports.ProductConnectionOfferState = {
    NOTSET: 'NOTSET',
    PENDING: 'PENDING',
    DENIED: 'DENIED',
    APPROVED: 'APPROVED',
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    CANCELED: 'CANCELED',
    UNREACHABLE: 'UNREACHABLE'
};
exports.ProductConnectionOfferStateLegacy = {
    INITIATED: 'INITIATED',
    DENIED: 'DENIED',
    PENDINGEVALUATE: 'PENDINGEVALUATE',
    PENDINGACCEPT: 'PENDINGACCEPT',
    REJECTED: 'REJECTED',
    ACCEPTED: 'ACCEPTED',
    WITHDRAWN: 'WITHDRAWN',
    CLOSED: 'CLOSED'
};
exports.ProductConnectionProductType = {
    RENT: 'RENT'
};
exports.ProductConnectionCategoryType = {
    SPLIT_RENT: 'SPLIT_RENT',
    MOVE_IN: 'MOVE_IN'
};
exports.AccountEnterOnboardingCategory = {
    SPLIT_RENT: 'SPLIT_RENT',
    MOVE_IN: 'MOVE_IN'
};
exports.AccountTagName = {
    RXP: 'RXP',
    RXP_MIGRATION: 'RXP_MIGRATION',
    RXP_EARLY_PAY_DDA: 'RXP_EARLY_PAY_DDA',
    WALLET_CX_ENABLED: 'WALLET_CX_ENABLED'
};
exports.GetAccountCategoryType = {
    SPLIT_RENT: 'SPLIT_RENT',
    MOVE_IN: 'MOVE_IN'
};
